<template>
    <div class="account-picker">

        <!-- Button -->
        <div>
            <button v-if="type == 'primary'" type="button" class="btn btn-primary" @click="showSelector">{{ label
                }}</button>
            <button v-if="type == 'default'" type="button" class="btn btn-default" @click="showSelector">{{ label
                }}</button>
            <button v-if="type == 'text'" type="button" class="text" @click="showSelector">{{ label }}</button>
            <button v-if="type == 'icon'" type="button" class="btn text" @click="showSelector"><span
                    class="fa fa-exchange"></span> {{ label }}</button>
        </div>

        <!-- Modal -->
        <div ref="picker" class="modal fade account-picker-modal" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
                        <h4 class="modal-title">Select Account</h4>
                    </div>
                    <div class="modal-body">
                        <div class="modal-subheader p-20">
                            <input type="text" class="form-control" v-model="accountFilter" ref="filter"
                                placeholder="Account Number or Name" @keyup.13="maybeSelectAccount" />
                        </div>
                        <div class="account-picker-list">
                            <account-list ref="list" :filter="accountFilter" :roles="roles" :services="services"
                                :delay="true" :selectedAccounts="selectedAccounts"
                                :selectedAccountNumbers="selectedAccountNumbers" :should_cc_hold="should_cc_hold"
                                @select="selectAccount" @update="getAccounts" @remove="removeAccount"></account-list>
                        </div>
                    </div>
                    <div class="modal-footer" style="margin-top:15px;">
                        <button v-show="multiple" type="button" class="btn btn-lg btn-secondary hidden-xs"
                            @click="removeAllAccounts" :disabled="selectedAccounts.length < 1"><i
                                class="fa fa-square-o"></i> Select None</button>
                        <button v-show="multiple" type="button" class="btn btn-lg btn-secondary hidden-xs"
                            @click="selectAllAccounts" :disabled="selectedAccounts.length >= available.length"><i
                                class="fa fa-check-square"></i>Select All</button>
                        <button v-if="multiple" type="button" class="btn btn-lg btn-primary" data-dismiss="modal"><i
                                class="fa fa-check"></i> Ok</button>
                        <button v-else type="button" class="btn btn-lg btn-secondary" data-dismiss="modal"><i
                                class="fa fa-times"></i> Close</button>

                        <!--<button type="button" class="btn btn-lg btn-default" data-dismiss="modal" v-html="(selectedAccounts.length > 0) ? 'OK' : 'Close'"></button>-->
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<style lang="scss">
@import '../../sass/_global_variables.scss';

.account-picker {
    display: inline-block;
}

.account-picker-modal {
    .modal-body {
        padding: 0px;

        .account-picker-search {
            padding: 20px;
            background-color: #f8f9fb;
            border-bottom: 1px solid #f1f1f1;
        }

        .account-picker-list {
            max-height: 300px;
            overflow: auto;
            padding: 0px;
        }
    }

    .modal-footer {
        padding: 10px;
    }
}
</style>

<script>
export default {
    props: {
        type: { default: 'primary' },
        label: { default: 'Select Account' },
        roles: { default: function () { return []; } },
        services: { default: function () { return []; } },
        multiple: { default: false },
        accounts: { default: function () { return []; } },
        should_cc_hold: { default: false }
    },

    data: function () {
        return {
            picker: null,
            accountFilter: '',
            available: [],
            selectedAccounts: [],
            selectIfAvailable: null
        }
    },

    computed: {
        selectedAccountNumbers: function () {
            return this.selectedAccounts.map(function (s) {
                if (s.account_nbr) return s.account_nbr;
            });
        }
    },

    watch: {
        available() {
            if (this.selectIfAvailable) {
                this.toggleAccount(this.selectIfAvailable)
                this.selectIfAvailable = ''
            }
        }
    },

    methods: {
        showSelector: function () {
            this.$refs.list.getAccounts();
            this.picker.modal('show');
            setTimeout(this.setFocus, 250);
        },

        setFocus: function () {
            this.$refs.filter.select();
        },

        maybeSelectAccount() {
            if (!isNaN(this.accountFilter)) {
                let available = this.available.find(account => account.account_nbr == this.accountFilter)
                if (available) {
                    this.toggleAccount(available.account_nbr)
                }
                else {
                    this.selectIfAvailable = this.accountFilter
                }
            }
        },

        toggleAccount(account_nbr) {
            let available = this.available.find(account => account.account_nbr == account_nbr)
            if (available) {
                let selected = this.selectedAccounts.find(account => account.account_nbr == account_nbr)
                this.accountFilter = ''
                if (selected) {
                    this.removeAccount(available.account_nbr)
                }
                else {
                    this.selectAccount(available.account_nbr)
                }
            }
        },

        selectAccount: function (accountNbr) {
            var request = this.$http.post('/user/change-account', {
                multiple: this.multiple,
                account_nbr: (this.multiple) ? null : accountNbr,
                account_nbrs: (this.multiple) ? this.selectedAccountNumbers.concat([accountNbr]) : [],
                roles: []
            }).then(function (response) {
                var account = response.body;
                if (!this.multiple) {
                    this.selectedAccounts = [];
                }
                this.selectedAccounts.push(account);
                this.$emit('select', account, this.multiple);
                if (!this.multiple) {
                    this.picker.modal('hide');
                    this.accountFilter = '';
                }
            });
        },

        selectAllAccounts: function () {
            let newlySelected = [];
            for (var i = 0; i < this.available.length; i++) {
                var account = this.available[i];
                if (this.selectedAccountNumbers.indexOf(account.account_nbr) == -1) {
                    this.selectedAccounts.push(account);
                    newlySelected.push(account);
                }
            }
            this.$emit('select', newlySelected, true);
        },

        getAccounts: function (accounts) {
            this.available = accounts;
        },

        removeAccount: function (accountNbr) {
            this.selectedAccounts.splice(this.selectedAccountNumbers.indexOf(accountNbr), 1);
            if (this.multiple) {
                var request = this.$http.post('/user/change-account', {
                    multiple: true,
                    account_nbrs: this.selectedAccountNumbers,
                    roles: []
                });
            }
            this.$emit('remove', accountNbr);
        },

        removeAllAccounts: function () {
            this.selectedAccounts = [];
            if (this.multiple) {
                var request = this.$http.post('/user/change-account', {
                    multiple: true,
                    account_nbrs: this.selectedAccountNumbers,
                    roles: []
                });
            }
            this.$emit('remove');
        },

        showHoldAlertIfNeeded() {
            if (!this.should_cc_hold) return;
            const hasHold = this.selectedAccounts.some(
                acc => Boolean(Number(acc.is_credit_and_collection))
            );

            if (hasHold) {
                swal({
                    title: 'Account on Hold',
                    text: 'This account is on hold due to an outstanding balance. Please review your open invoices to bring the account current, or call 402-334-7770 for questions.',
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
            }
        }

    },

    mounted: function () {
        var vm = this;
        vm.picker = $(vm.$refs.picker);
        vm.picker.on('hidden.bs.modal', function () {
            vm.$emit('closed');
            vm.showHoldAlertIfNeeded();
        });
        $('body').append(vm.picker);
    }

}
</script>



// WEBPACK FOOTER //
// account-picker.vue?15ed893e